define('C3.ShoppingExtensions.Carousel.Items.CellViewUpdated'
, 	[
		
		'SCView'
    ,   'Product.Model'
    ,   'Cart.QuickAddToCart.View'
    ,   'ProductViews.Option.View'
    ,   'ProductLine.StockDescription.View'
    ,   'Utils'
    ,   'LiveOrder.Model'
    ,   'Backbone.CompositeView'
    ,   'Backbone.CollectionView'
    ,   'underscore'
    ,   'Session'
    ,   'Profile.Model'
    ,   'C3.ShoppingExtensions.LoginRegister.View'
    ,   'c3_shoppingextensions_carousel_items_cellviewupdated.tpl'
    ,   'AjaxRequestsKiller'
    ,    'C3.ShoppingExtensions.GroupAddToCart.View'
    ,   'GoogleTagManager'
    ,   'Tracker'
	],
function (
		
		SCViewModule
    ,   ProductModel
    ,   CartQuickAddToCartView
    ,   ProductViewsOptionView
    ,   ProductLineStockDescriptionView
    ,   Utils
    ,   LiveOrderModel    
    ,   BackboneCompositeView
    ,   BackboneCollectionView
    ,   _
    ,   Session
    ,   ProfileModel
    ,   LoginRegisterView
    ,   c3_shoppingextensions_carousel_items_cellviewupdated_tpl
    ,   AjaxRequestsKiller
    ,   GroupAddToCart
    ,   GoogleTagManager
    ,   Tracker
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function CarouselItemsCellViewUpdated (options) {
        SCView.call(this, options);

        //console.log(options)
        this.model = options.model;
        this.configuration = options.configuration;
        this.application = options.application;
        this.container = options.container;
        this.origin = options.origin;
        this.hideArrows = options.hideArrows;

        this.template = c3_shoppingextensions_carousel_items_cellviewupdated_tpl;

        BackboneCompositeView.add(this);

        this.showLoginRegisterPopup = function showLoginRegisterPopup(e){
            e.stopPropagation();
            e.preventDefault();
            
            var Layout = this.application.getComponent('Layout');
            //console.log(Layout)

            var view = new LoginRegisterView({
                application: Layout.application
            });



            if (view)
            Layout.showContent(view, {showInModal: true});
        }

        this.groupItemPopup = function(e){
            var self = this;
        var $element = jQuery(e.currentTarget)
        var url = $element.attr('data-url');
        var lightboxURL = $element.attr('data-lightbox-url');
        var product = new ProductModel();
        var promise = jQuery.Deferred();
        var item = product.get('item');

        //console.log($element)
        //console.log(url)

        //var layout = this.options.layout
        var   application = this.application
        ,     Layout = this.container.getComponent('Layout');
        //console.log(Layout)
        
        item.fetch({
            data: {url:url},
            killerId: AjaxRequestsKiller.getKillerId(),
            pageGeneratorPreload: true
        }).then(
            // Success function
            function(data, _result, jqXhr) {
                //console.log(data)
               if (!item.isNew()) 
                {
                    if (item.get('urlcomponent') &&
                        SC.ENVIRONMENT.jsEnvironment === 'server') {
                            nsglobal.statusCode = 301;
                            nsglobal.location = Utils.addSlashToURL(product.generateUrl());
                    }
                   if (data.corrections && data.corrections.length > 0) 
                   {
                       if ( item.get('urlcomponent') &&
                           SC.ENVIRONMENT.jsEnvironment === 'server') {
                                nsglobal.statusCode = 301;
                                nsglobal.location =
                                Utils.addSlashToURL(data.corrections[0].url) +
                                product.getQuery();
                        }else 
                        {
                           var view = new GroupAddToCart({
                                application: application ,model:product
                            });
                            if (view)
                                Layout.showContent(view, {showInModal: true})
                        
                            promise.reject();
                        }
                    }
                        // self.bindModel();
                        promise.resolve();
                } 
                else if (jqXhr.status >= 500) {
                    // application.getLayout().internalError();
                    promise.reject();
                }
                else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') 
                {
                        // We just show the 404 page
                        // application.getLayout().notFound();
                        promise.reject();
                }
            },
            // Error function
            function(jqXhr) 
            {
                // this will stop the ErrorManagment module to process this error
                // as we are taking care of it
                jqXhr.preventDefault = true;
                if (jqXhr.status >= 500) {
                    // application.getLayout().internalError();
                    promise.reject();
                } else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') {
                    // We just show the 404 page
                    // application.getLayout().notFound();
                    promise.reject();
                }
            });
            //$('#site-footer').addClass('remove-footer-positioning')
            return promise; 
       }

        this.addQuantity = function addQuantity(e){
            var self = this;
            //console.log(SC)
            var $element = jQuery(e.currentTarget);
            var quantity_input = $element.parent().find('.item-quantity-value');
            var button_minus = $element.parent().find('.minus-button');
            var find_title_ele = $element.closest('.e2');
            var cart = this.application.getComponent('Cart');
            var lines=[];

            var itemQtyInCurrentOrder = 0;

            var liveOrder = LiveOrderModel.getInstance();
            //console.log(self.model.get('_id'))

            var internalID=quantity_input.attr("data-id");

            //console.log(internalID)
            
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                return line.get('item').get('internalid') == internalID;
            });
            
            if(lineData.length > 0)
            {
            var lineQuantity=lineData[0].get('quantity');
            itemQtyInCurrentOrder = lineQuantity;
            }

            var elementParent = $element.parent('.plus-icon');      
            //console.log(elementParent)

            var trashCane = $element.parent().find('.product-trash-tray');
            
           // console.log(find_title_ele)
            quantity_input.show();
           // button_minus.show();

            var parentEle = $element.parent('.plus-icon');
            if(!(parentEle.hasClass('expand-plus-icon')))
            parentEle.addClass('expand-plus-icon');

            find_title_ele.addClass('newly-added-css');
            
            var old_value = quantity_input.text();

             if(elementParent.hasClass('add-to-cart-buttons-opened'))
             {
            var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
            quantity_input.text(new_val);
            }
            
            var quantity = quantity_input.text();
            var internalID=quantity_input.attr("data-id");


            if(quantity == 1)
            {
                trashCane.show();
                button_minus.hide();
                quantity_input.css('text-align','left');
                
            }
            else    
            {
                 button_minus.show();
                trashCane.hide();
                quantity_input.css('text-align','center');
            }

           // console.log(quantity)
            
            if(quantity>0)
            {
                if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
                {
                    $element.text('+');
                    $element.removeClass('plus-button-additional');

                    elementParent.addClass('add-to-cart-buttons-opened');
                    elementParent.removeClass('plus-icon-additional');

                }else
                {
                    var lineData={quantity: parseFloat(1),
                                  item: {internalid: parseFloat(internalID)}
                    };
                    lines.push(lineData);
                    //console.log(lines)
                    SC.loadingIndicatorShow();
                    cart.addLines({lines: lines}).then(function() {
                        SC.loadingIndicatorHide();
                        if(!Utils.isPhoneDevice())
                        jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");

                        //Snippet for GTM DataLayer
                        var cartLinesDL = liveOrder.get('lines')
                        ,   cartLinesModelsDL = cartLinesDL.models
                        ,   finalCartArray = []

                        _.each(cartLinesModelsDL, function(line) {
                            var lineItem = line.get('item')
                            ,   lineItemName = lineItem.get('displayname')
                            ,   lineItemSKU = lineItem.get('itemid')
                            ,   lineQty = line.get('quantity')
                            ,   lineRate = line.get('rate')
                            ,   lineGroup = lineItem.get('custitemproduct_category')
                            ,   lineCategory =  lineItem.get('custitem168')

                            finalCartArray.push({
                                'item': lineItemSKU,
                                'quantity':  lineQty,
                                'price': lineRate,
                                'unique_id': lineItemSKU,
                                'ProductGroup' : lineGroup,
                                'ProductCategory' : lineCategory

                            })
                        });

                        const gtm = GoogleTagManager;
                        const eventName = 'cartInfo';
                         const eventData = {
                            event: eventName,
                            cartUpdates: finalCartArray
                         }
                         Tracker.trigger(eventName, eventData);
                         gtm.pushData(eventData);
                        //console.log(finalCartArray)
                         
                            var appendParentElement = $('.append-abandoned-cart-items')
                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
                        
                            var sku = self.model.get('itemid')
                            var carouselItemsAppend = $('.Carousel-Items-Append');
                            //carouselItemsAppend.html("<script>window.dataLayer = window.dataLayer || [];window.gtag('event', 'mostpopularitems', {'product': "+sku+",'page_location': '/' });</script>");
                            carouselItemsAppend.html(
                                "<script>" +
                                "window.dataLayer = window.dataLayer || [];" +
                                "if (typeof window.gtag === 'function') {" +
                                    "window.gtag('event', 'mostpopularitems', {" +
                                        "'product': '" + sku + "'," +
                                        "'page_location': '/' " +
                                    "});" +
                                "}" +
                                "<\/script>"
                            );
                            var gaEventQty=quantity || 1
                            ,   gaEventPrice=quantity_input.attr("data-price") || 0
                            ,   gaEventSku = quantity_input.attr("data-sku")
                            ,   gaEventManufacturer = quantity_input.attr("data-manufacturer")
                            ,   gaEventItemName = quantity_input.attr("data-itemname")

                            var addToCartTotalValue = gaEventQty * gaEventPrice;
                            var addToCartAppend = $('.Carousel-Items-AddToCart');
                            /*addToCartAppend.html(
                                "<script>" +
                                "window.dataLayer = window.dataLayer || [];" +
                                "window.gtag('event', 'add_to_cart', {" +
                                    "'currency': 'USD'," +
                                    "'value': " + addToCartTotalValue + "," +
                                    "'items': [{" +
                                        "'item_id': '" + gaEventSku + "'," +
                                        "'item_name': '" + gaEventItemName + "'," +
                                        "'manufacturer': '" + gaEventManufacturer + "'," +
                                        "'price': " + gaEventPrice + "," +
                                        "'quantity': " + gaEventQty +
                                    "}]" +
                                "});" +
                                "<\/script>"
                            );*/

                            var script = document.createElement('script');
                            script.type = 'text/javascript';
                            script.text = `
                                window.dataLayer = window.dataLayer || [];
                                window.gtag('event', 'add_to_cart', {
                                    'currency': 'USD',
                                    'value': ${addToCartTotalValue},
                                    'items': [{
                                        'item_id': '${gaEventSku}',
                                        'item_name': '${gaEventItemName}',
                                        'manufacturer': '${gaEventManufacturer}',
                                        'price': ${gaEventPrice},
                                        'quantity': ${gaEventQty}
                                    }]
                                });
                            `;
                            document.head.appendChild(script);
                    });
                    elementParent.addClass('add-to-cart-buttons-opened');   
                }
            }
        }

        this.removeQuantity = function removeQuantity(e){
            const $element = jQuery(e.currentTarget);
            const quantity_input = $element.parent().find('.item-quantity-value');
            const find_title_ele = $element.closest('.e2');
            const old_value = quantity_input.text();
            const cart = this.application.getComponent('Cart');
            var lines=[];

            if(old_value==1 )
            {
                var parentEle = $element.parent('.plus-icon');
                if(parentEle.hasClass('expand-plus-icon'))
                parentEle.removeClass('expand-plus-icon');

             if(parentEle.hasClass('add-to-cart-buttons-opened'))
                parentEle.removeClass('add-to-cart-buttons-opened');

                find_title_ele.removeClass('newly-added-css');
                let new_val = parseFloat(old_value) - 1;
               
                if(new_val == 0)
                    quantity_input.text(1);
                else
                    quantity_input.text(new_val);
                
                $element.attr("style","display:none !important;");
                quantity_input.hide();
            }
            else if(old_value>1 ){
                let new_val = parseFloat(old_value) - 1;
                quantity_input.text(new_val);

                if(old_value == 2)
                {
                    var trashCane = $element.parent().find('.product-trash-tray');
                    var button_minus = $element.parent().find('.minus-button');
                    //console.log(button_minus)
                    button_minus.attr("style","display:none !important;");
                    trashCane.show();
                    quantity_input.css('text-align','left');
                    
                }
            }
            var internalID=quantity_input.attr("data-id");
            
            var liveOrder = LiveOrderModel.getInstance();
            
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                return line.get('item').get('internalid') == internalID;
            });
            var lineQuantity=lineData[0].get('quantity');
            
            if(lineQuantity==1)
                liveOrder.removeLine(
                lineData[0].set('quantity',parseFloat(lineQuantity)-1));
            else
            {
                liveOrder.updateLine(
                lineData[0].set('quantity',parseFloat(lineQuantity)-1));
                setTimeout(function(){
                    if(!Utils.isPhoneDevice())
                        jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
                }, 1000);
            }

            //Snippet for GTM DataLayer
            var cartLinesDL = liveOrder.get('lines')
            ,   cartLinesModelsDL = cartLinesDL.models
            ,   finalCartArray = []

            _.each(cartLinesModelsDL, function(line) {
                var lineItem = line.get('item')
                ,   lineItemName = lineItem.get('displayname')
                ,   lineItemSKU = lineItem.get('itemid')
                ,   lineQty = line.get('quantity')
                ,   lineRate = line.get('rate')
                ,   lineGroup = lineItem.get('custitemproduct_category')
                ,   lineCategory =  lineItem.get('custitem168')

                finalCartArray.push({
                    'item': lineItemSKU,
                    'quantity':  lineQty,
                    'price': lineRate,
                    'unique_id': lineItemSKU,
                    'ProductGroup' : lineGroup,
                    'ProductCategory' : lineCategory

                })
            });

            const gtm = GoogleTagManager;
            const eventName = 'cartInfo';
             const eventData = {
                event: eventName,
                cartUpdates: finalCartArray
             }
             Tracker.trigger(eventName, eventData);
             gtm.pushData(eventData);
             //console.log(gtm.win)
            console.log(finalCartArray)
            /*var _etmc = [];
            _etmc.push(['trackCart', {
                'cart': finalCartArray
            }]);*/
            //setTimeout(function() { 
            var appendParentElement = $('.append-abandoned-cart-items')
            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
         //}, 1000); 
        }

        this.getThumbnail = function getThumbnail(){
            var item_images_detail = this.model.get('itemimages_detail') || {};

                // If you generate a thumbnail position in the itemimages_detail it will be used
                if (item_images_detail.thumbnail)
                {
                    if (_.isArray(item_images_detail.thumbnail.urls) && item_images_detail.thumbnail.urls.length)
                    {
                        return item_images_detail.thumbnail.urls[0];
                    }

                    return item_images_detail.thumbnail;
                }

                // otherwise it will try to use the storedisplaythumbnail
                if (SC.ENVIRONMENT.siteType && SC.ENVIRONMENT.siteType === 'STANDARD' && item.get('storedisplaythumbnail'))
                {
                    return {
                        url: item.get('storedisplaythumbnail')
                    ,   altimagetext: this.model.get('storedisplayname2')
                    };
                }
                // No images huh? carry on

                var parent_item = this.model.get('_matrixParent');
                // If the item is a matrix child, it will return the thumbnail of the parent
                if (parent_item && parent_item.get('internalid'))
                {
                    return parent_item.get('_thumbnail');
                }

                var images = Utils.imageFlatten(item_images_detail);
                // If you using the advance images features it will grab the 1st one
                if (images.length)
                {
                    return images[0];
                }

                // still nothing? image the not available
                return {
                    url:  Utils.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg', this.configuration.get('imageNotAvailable'))
                ,   altimagetext: this.model.get('storedisplayname2')
                };
        }

        this.getUrlLogin = function getUrlLogin(){
            //console.log('getUrlLogin')
            var url = Session.get('touchpoints.login') +
                '&origin=' +
                (this.configuration.get('currentTouchpoint') || 'home') +
                '&origin_hash=';
            return (url +
                encodeURIComponent(this.options.origin === 'PDPQUICK'
                    ? this.model.generateURL().replace('/', '')
                    : Backbone.history.fragment));
        }

        this.mostPopularClick = function mostPopularClick(e){
            e.preventDefault();

            var ele = $(e.currentTarget)
            //,   eleHashTag = ele.attr('data-element')
            //console.log(e)

            var sku = this.model.get('itemid')
            var carouselItemsAppend = $('.Carousel-Items-Append');
            carouselItemsAppend.html("<script>window.dataLayer = window.dataLayer || [];window.gtag('event', 'mostpopularitems', {'product': '"+sku+"', 'action': 'productview','page_location': '/' });</script>");
               
        }
    }

    CarouselItemsCellViewUpdated.prototype = Object.create(SCView.prototype);
    CarouselItemsCellViewUpdated.prototype.constructor = CarouselItemsCellViewUpdated;

    CarouselItemsCellViewUpdated.prototype.render = function () {
        SCView.prototype.render.call(this);
           
    }

    CarouselItemsCellViewUpdated.prototype.getChildViews = function () {
        return{
            'Cart.QuickAddToCart': function ()
            {
                var product = new ProductModel({
                    item: this.model
                ,   quantity: this.model.get('_minimumQuantity', true)
                });

                return new CartQuickAddToCartView({
                    model: product
                ,   application: this.options.application
                });
            }
        }      
    }

     CarouselItemsCellViewUpdated.prototype.getEvents = function () {
        return {
            'click [data-action="plus"]': 'addQuantity',
            'click [data-action="minus"]': 'removeQuantity',
            'click [data-action="item-quick-view"]': 'groupItemPopup',
            'click [data-action="show-login-register-popup"]': 'showLoginRegisterPopup',
            'click [data-action="mostpopular-click"]': 'mostPopularClick'
        }
     }

    CarouselItemsCellViewUpdated.prototype.getContext = function () {
         var applyStrikeThroughPrice = false
            ,   special_formatted_pricelevel1 = ''
            ,   special_formatted_pricelevel5 = ''
            ,   qtyAvailableInv = this.model.get('custitem_qty_available_inv')
            ,   qtyAvailableKit = this.model.get('custitem_qty_available_kit')
            ,   itemType = this.model.get('itemtype')
            ,   enableOutOfStock = this.model.get('custitem_celigo_shopify_enable_out_sto')
            ,   isWebsiteCategoryProduct = this.model.get('custitem157')
            ,   outOfStockDisplay = this.model.get('custitem_aa_out_of_stock_display')
            ,   showOutOfStockButton = false
            ,   showContactForPricingButton = false
            ,   serialLotFunctionality = this.model.get('custitem_pdp_seriallot_number_function')
            ,   serialLotMinPrice = this.model.get('custitem_icm_ain_min_price')
            ,   serialLotMaxPrice = this.model.get('custitem_icm_ain_max_price')
            ,   showOutofStock = false;

            //console.log(isWebsiteCategoryProduct)

            if(qtyAvailableInv == undefined)
                qtyAvailableInv = 0;

            if(qtyAvailableKit == undefined)
                qtyAvailableKit = 0;
            
            if(itemType == "Kit")
            {
                //Item Qty is 0 and Allow out of stock checkbox is not checked
                if(qtyAvailableKit <= 0 && enableOutOfStock == false)
                {
                    showOutofStock = true;

                    if(outOfStockDisplay == "Out of Stock")
                        showOutOfStockButton = true;
                    else if(outOfStockDisplay == "Contact for Pricing")
                        showContactForPricingButton = true; 
                }
            }
            else if(itemType == 'InvtPart' || itemType == 'Assembly')
            {
                //Item Qty is 0 and Allow out of stock checkbox is not checked
                if(qtyAvailableInv <= 0 && enableOutOfStock == false)
                {
                    showOutofStock = true;

                    if(outOfStockDisplay == "Out of Stock")
                        showOutOfStockButton = true;
                    else if(outOfStockDisplay == "Contact for Pricing")
                        showContactForPricingButton = true; 
                }
            }


            var lightboxItem = this.model.get('custitem_lightbox_item_url_component');
            var finalLightboxUrl = ''
            ,   isKitItemOnly = this.model.get('custitem_kit_item_only') 


            if(lightboxItem !== '' /*&& kititemonly == true*/)
            {
                finalLightboxUrl = "/"+lightboxItem;
            }

            
            //if(this.options.origin !== "mostpopular")
            //{
            var price_detail = this.model.get('onlinecustomerprice_detail')
            ,   ItemPrice = ''
            //console.log(price_detail)
            if(price_detail)
            {
                //var price_container_object = this.model.getPrice()
                var pricelevel1 = this.model.get('pricelevel1')
                ,   pricelevel1_formatted = this.model.get('pricelevel1_formatted')
                ,   pricelevel5_formatted = price_detail.onlinecustomerprice_formatted
                ,   onlinecustomerprice_detail = price_detail
                ,   applyStrikeThroughPrice = false
                ,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
                ,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice
                ,   ItemPrice = onlinecustomerprice_detail.onlinecustomerprice_formatted
                ,   savePrice = 0
                ,   savePercent=0
                ,   discountPercentage=0;

                 if(pricelevel1 && pricelevel1 > onlineprice)
                {
                    //console.log(pricelevel1.toLocaleString('en'));
                    applyStrikeThroughPrice = true;
                }

                if(pricelevel1_formatted)
                    special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
                
                if(pricelevel5_formatted)
                    special_formatted_pricelevel5 = pricelevel5_formatted.substr(0, pricelevel5_formatted.indexOf('.'));
                
                /*if(price_container_object)
                {
                    onlineprice = price_container_object.price_formatted;
                    if(onlineprice)
                    special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
                }   */

                var currPrice = pricelevel5 || pricelevel1 || 0; 
                if( currPrice < 5){
                    showOutofStock = true;
                } 
             }
            //}

            var itemQtyInCurrentOrder = 0;

            //using lightbox field condition instead of relateditems
            //if(subCategoriesList.length  == 0)
            if(lightboxItem == '')
            {
                var self = this;
                var liveOrder = LiveOrderModel.getInstance();
                //console.log(liveOrder.get('lines'))
                
                var lineData=liveOrder.get('lines').filter(function(line)
                {   
                    return line.get('item').get('internalid') == self.model.get('internalid');
                });
                if(lineData.length > 0)
                {
                var lineQuantity=lineData[0].get('quantity');
                itemQtyInCurrentOrder = lineQuantity;
                }
            }

             var urlComponent = "product/"+this.model.get('internalid')
             if(this.model.get('urlcomponent'))
                urlComponent = this.model.get('urlcomponent')

            /*if(isKitItemOnly == true)
                showOutofStock = true;*/

            if(applyStrikeThroughPrice && showOutofStock==false)
                {
                    savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
                    discountPercentage = Number(savePrice / pricelevel1) * 100;
                    savePercent=Math.trunc(discountPercentage)+ "%";
                }
            return{
            //    itemURL: this.getFullLink()
                //@property {String} itemName
               itemName: this.model.get('storedisplayname2') || this.model.Name
                // @property {ImageContainer} thumbnail
            ,   thumbnail: this.getThumbnail()
                //@property {String} sku
            ,   sku: this.model.get('itemid')
                //@property {String} sku
            /*,   url: this.model.get('urlcomponent')*/
            ,   url : urlComponent 
                // @property {String} itemId
            ,   itemId: this.model.get('internalid')
                // @property {Item.Model} model
            ,   model: this.model
                //@property {Boolean} showRating
            ,   showRating: SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled
                //@property {String} track_productlist_list
            ,   track_productlist_list: this.model.get('track_productlist_list')
                //@property {String} track_productlist_position
            ,   track_productlist_position: this.model.get('track_productlist_position')
                //@property {String} track_productlist_category
            ,   track_productlist_category: this.model.get('track_productlist_category')
            //,   isWebsiteCategoryProduct : this.model.get('custitem_kit_item_only') //Using Kit Item Only field
            ,   itemQtyInCurrentOrder : itemQtyInCurrentOrder
            ,    itemQtyInCurrentOrderCheck : itemQtyInCurrentOrder > 0
            ,    itemQtyInCurrentOrderCheck2 : itemQtyInCurrentOrder < 1
            ,    origin : this.origin
            ,    hideArrows : this.hideArrows
            ,    applyStrikeThroughPrice : applyStrikeThroughPrice
            ,    BasePriceFormatted : special_formatted_pricelevel1
            ,    OnlinePriceFormatted : special_formatted_pricelevel5
            ,    showOutofStock : showOutofStock
            ,    plpPrice : ItemPrice
            ,    isWebsiteCategoryProduct : isWebsiteCategoryProduct
            ,    lightBoxItemURL : finalLightboxUrl
            ,    hidePricing: ProfileModel.getInstance().hidePrices()
            ,    urlLogin: this.getUrlLogin()
            ,    savePrice : savePrice
            ,    savePercent:savePercent
            ,    onlinePrice : this.model.get('onlinecustomerprice')
            ,    itemManufacturer : this.model.get('custitem_manufacturer')
            ,    showContactForPricingButton : showContactForPricingButton
            ,    showOutOfStockButton : showOutOfStockButton
            ,    serialLotFunctionality : serialLotFunctionality
            ,     serialLotMinPrice: Utils.formatCurrency(serialLotMinPrice)
            ,     serialLotMaxPrice: Utils.formatCurrency(serialLotMaxPrice)
            ,     hasSerialMinMax: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '')
            
            ,    hasSerialMinOnly: (serialLotMinPrice != null && serialLotMinPrice !== '') && !(serialLotMaxPrice != null && serialLotMaxPrice !== '')
            ,    hasSerialMaxOnly: !(serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '')
            ,    serialMinMaxEqual: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '') && parseFloat(serialLotMinPrice) === parseFloat(serialLotMaxPrice)
        }
    }

    return CarouselItemsCellViewUpdated
});
